import React from "react";
import { Card, InputBase, IconButton, Stack } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function Filter({ init, setFilter, clearFilter }) {
  const handleChange = (event) => {
    setFilter({ title: event.target.value });
  };

  return (
    <Stack
      top={0}
      zIndex={1}
      width="100%"
      position="sticky"
      bgcolor="transparent"
    >
      <Card
        elevation={4}
        sx={{
          p: 1,
          height: 64,
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderRadius: "0 0 16px 16px",
        }}
      >
        <InputBase
          autoFocus={false}
          placeholder="جستجو..."
          value={init?.title || ""}
          onChange={handleChange}
          sx={{ flex: 1, color: "text.secondary" }}
          inputProps={{ "aria-label": "جستجو..." }}
        />
        <IconButton
          size="small"
          onClick={clearFilter}
          sx={{ bgcolor: "action.hover" }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Card>
    </Stack>
  );
}
